/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const FileUploadPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The input props
   */
  inputProps: PropTypes.object,

  /**
   * The render errors props
   */
  renderErrors: PropTypes.func,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,

  /**
   * The upload props
   */
  uploadProps: PropTypes.object,
};

export default FileUploadPropTypes;
